import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/router'
import store from '@/store/store'
import i18n from '@/app/plugins/i18n/i18n'
import {initComponents} from '@/app/config/component'
import {initFilters} from '@/app/config/filters'
import VuePluginInitializer from '@/app/plugins/vue-plugin-initializer'
import {initPrototype} from '@/app/config/prototype'
import {initDirectives} from '@/app/config/directive'

import '@fortawesome/fontawesome-free/css/all.css'

VuePluginInitializer.init()

Vue.config.productionTip = false
initComponents()
initDirectives()
initFilters()
initPrototype(i18n)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
